<template>
    <el-dialog title="用户信息" :visible.sync="showModal" v-if="showModal" width="824px" :close-on-click-modal="false"
        :destroy-on-close="true">
        <template v-if="loading">
            <el-skeleton :rows="10" animated />
        </template>
        <template v-else>
            <div class="avatar-box">
                <el-avatar :size="128" :src="userProfile.head_img"></el-avatar>
            </div>
            <div class="user-base-info">
                <h3 class="signs">个人信息</h3>
                <div class="info-row">
                    <span class="info-item">昵称: {{ userProfile.name }}</span>
                    <span class="info-item">性别: {{ userProfile.gender === 1 ? '男' : '女' }}</span>
                </div>
                <div class="info-row">
                    <!-- <span class="info-item">生日: {{ initTime(userProfile.age) }}</span> -->
                    <span class="info-item">年龄段: {{
                        userProfile.age_group === 1 ? '20岁以下' :
                        userProfile.age_group === 2 ? '21~30岁' :
                            userProfile.age_group === 3 ? '31~40岁' :
                                userProfile.age_group === 4 ? '41~50岁' :
                                    userProfile.age_group === 5 ? '51岁以上' : '未设置'
                    }} </span>
                    <span class="info-item">手机: {{ userProfile.account }}</span>
                </div>
                <div class="info-row">
                    <span class="info-item">邮箱: {{ userProfile.email ? userProfile.email : '无' }}</span>
                    <span class="info-item">微信ID: {{ userProfile.wx_id ? userProfile.wx_id : '无' }}</span>
                </div>
                <div class="info-row">
                    <span class="info-item" v-if="userProfile.country && userProfile.provinces">居住地: {{ userProfile.country
                    }}，{{ userProfile.provinces }}</span>
                    <span v-else class="info-item">居住地: 无</span>
                </div>
                <div class="specialties">
                    <span class="specialties-subtitle">擅长领域: </span>
                    <template v-if="userProfile.evaluation_type_field.length > 0">
                        <el-tag v-for="item in userProfile.evaluation_type_field" :key="item.id" size="medium">{{
                            item.name
                        }}</el-tag>
                    </template>

                    <div v-else>
                        无
                    </div>
                </div>
                <div style="display:flex;margin-top: 15px;" v-if="showRemark">
                    <div style="margin-right:10px;">备注：</div>
                    <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入给用户的备注" style="width:400px"
                        v-model="remarkValue">
                    </el-input>
                    <el-button @click="submitRemark" v-if="showRemark" type="primary"
                        style="margin-left: 50px;height: 40px;align-self: flex-end;">
                        提交
                    </el-button>
                </div>
                <h3 class="signs">资质证明</h3>
                <template v-if="userProfile.user_channel.length > 0">
                    <div class="platform-item" v-for="platform in userProfile.user_channel" :key="platform.id">
                        <el-tag class="platform-name">{{ platform.evaluation_channel_info.name }}</el-tag>
                        <el-form label-position="left" label-width="80px">
                            <el-form-item v-for="item in platform.data" :key="item.id" :label="item.name">
                                <el-input style="max-width:412px;" :value="item.content"></el-input>
                            </el-form-item>
                        </el-form>
                        <!-- <div class="info-row">
                        <span class="info-item" v-for="item in platform.data" :key="item.id">{{ item.name }}: {{
                            item.content
                        }}</span>
                    </div> -->
                    </div>
                </template>

                <div v-else>
                    无
                </div>
                
            </div>
        </template>
        <div style="margin-top: 32.76px;">
            <el-button @click="trunOff">返回</el-button>
        </div>
    </el-dialog>
</template>

<script>
import request from "@/utils/request";

export default {
    data: () => ({
        loading: false,
        userProfile: {},
        remarkValue: '',
    }),
    props: {
        show: {
            default: false,
            type: Boolean
        },
        userID: String | null,
        showRemark: { // 是否显示备注
            default: false,
            type: Boolean
        }
    },
    methods: {
        // 提交备注
        async submitRemark() {
            this.$confirm(`此操作将提交用户备注, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                console.log(this.remarkValue)
                let params = {
                    user_id: this.userID,
                    remarks: this.remarkValue
                }
                request({
                    url: "/api/backend/user/remarks",
                    method: "POST",
                    data: params,
                }).then(() => {
                    this.$message({
                        message: '添加备注成功!',
                        type: 'success'
                    });
                    this.$emit("onUpdate");
                    this.trunOff()
                })
            })
        },
        trunOff() {
            this.showModal = false
        },
        initTime(timestamp) {
            const date = new Date(timestamp);
            const years = date.getFullYear()
            const month = date.getMonth()
            const day = date.getDate()
            return `${years}-${month + 1}-${day}`;
        },
        async getUserProfile(user_id) {
            this.loading = true
            const { data } = await request({
                url: "/api/backend/userInfo",
                method: "GET",
                params: { user_id },
            })
            this.remarkValue = data.remarks
            this.userProfile = data
            this.loading = false
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    // watch: {
    //     show(v) {
    //         if (v) {
    //             this.getUserProfile(this.userID)
    //         }
    //     }
    // }
    created() {
        this.getUserProfile(this.userID)
    }
}
</script>

<style lang="scss" scoped>
.avatar-box {
    text-align: center;
}

.signs {
    position: relative;

    // margin: 0;
    margin-top: 32.76px;
    // margin-left: 10px;
    // font-size: 1rem;

    // &:first-child {
    //     margin: 0;
    // }

    // &::before {
    //     content: '';
    //     position: absolute;
    //     left: -10px;
    //     top: 0;
    //     width: 3px;
    //     height: 100%;
    //     background-color: hsl(220, 93%, 72%);
    // }
}

.info-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 16.38px;
    row-gap: 16.38px;
    column-gap: 10px;

    &:first-child {
        margin: 0;
    }

    .info-item {
        font-size: 1rem;
    }
}

.specialties {
    display: flex;
    align-items: center;
    margin-top: 16.38px;

    .specialties-subtitle {
        font-size: 1rem;
        margin-right: 10px;
    }
}

.platform-item {
    margin-top: 30px;

    .platform-name {
        font-size: 0.9rem;
        font-weight: 600;
        margin-left: -10px;
        margin-bottom: 22px;
    }
}

.platform-item:first-child {
    margin-top: 0;
}

.platform-item:first-child {
    margin: 0;
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
</style>